// Felt Surface Layer: Micro-texture, directional light
import * as PIXI from 'pixi.js';
import { hexToPixi } from './colorUtils';

export function createFeltSurface(width: number, height: number, theme: { felt: string }) {
  const container = new PIXI.Container();
  const felt = new PIXI.Graphics();
  felt.ellipse(width / 2, height / 2, width * 0.41, height * 0.20).fill({ color: hexToPixi(theme.felt) });

  // Directional light overlay (simple semi-transparent white ellipse)
  const light = new PIXI.Graphics();
  light.ellipse(width / 2, height / 2.3, width * 0.18, height * 0.06).fill({ color: 0xffffff, alpha: 0.08 });

  container.addChild(felt, light);
  return container;
}
